<nav class="sidebar">
  <div class="sidebar-header">

    <!--- Logo -->
    <a class="sidebar-brand nobleui-logo" routerLink="/">
      <span><img src="/assets/images/pay10logo.png" class="img-fluid"></span>
    </a>
    <!--- Toggler -->
    <div #sidebarToggler (click)="toggleSidebar($event)" class="sidebar-toggler not-active">
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>
  <div (mouseenter)="operSidebarFolded()" (mouseleave)="closeSidebarFolded()" [perfectScrollbar] class="sidebar-body">

    <!--- Sidemenu start -->
    <!-- 
    <ul #sidebarMenu class="sidebar-nav metismenu list-unstyled" id="sidebar-menu">
      <ng-container #menuListItem *ngFor="let item of menuItems;let i=index;">
        <li *ngIf="item.isTitle" class="nav-item nav-category list-unstyled d-none" >{{ item.label }}</li>

        <li *ngIf="!item.isTitle" class="nav-item" (click)="isOpen($event,i)" id="{{i}}">

          <a *ngIf="hasItems(item)" class="nav-link" href="javascript:void(0);">
            <i *ngIf="item.icon" [attr.data-feather]="item.icon" appFeatherIcon class="link-icon"></i>
            <span class="link-title"></span>  <small class="name">{{ item.label }}</small>
            <span appFeatherIcon class="link-arrow" data-feather="chevron-down"></span>
          </a>

          <a *ngIf="!hasItems(item)" [attr.data-parent]="item.parentId" [routerLink]="item.link"
             class="nav-link nav-link-ref" (click)="openUrl(item.link)">
            <i *ngIf="item.icon" [attr.data-feather]="item.icon" appFeatherIcon class="link-icon"></i>
            <span class="link-title"></span> <small class="name">{{ item.label }}</small>
            <span *ngIf="item.badge" class="badge bg-{{item.badge.variant}}">{{item.badge.text}}</span>
          </a>

          <ul *ngIf="hasItems(item)" aria-expanded="false" class="sidebar-nav sub-menu nav-second-level d-none" id="{{i}}sub">

            <li *ngFor="let subitem of item.subItems;let j=index" [ngClass]="{'side-nav-item': hasItems(subitem)}" class="nav-item" id="{{i}}{{j}}" (click)="isOpenSubMenu(i,j,$event)">
              <a *ngIf="hasItems(subitem) && !levelExclude.includes(subitem.label)" class="nav-link side-nav-link-a-ref" href="javascript:void(0);">
                <i *ngIf="subitem.icon" [attr.data-feather]="subitem.icon" appFeatherIcon class="link-icon"></i>
                <span class="link-title"> {{ subitem.label }}</span>
                <span appFeatherIcon class="link-arrow" data-feather="chevron-down"></span>
              </a>

              <a   (click)="linkUrl(subitem.link)"  *ngIf="!hasItems(subitem) || (hasItems(subitem) && levelExclude.includes(subitem.label))" [attr.data-parent]="subitem.parentId" [routerLink]="subitem.link"
                 class="nav-link nav-link-ref">
                <i *ngIf="subitem.icon" [attr.data-feather]="subitem.icon" appFeatherIcon class="link-icon"></i>
                {{ subitem.label }}
              </a>
            
             

              <ul *ngIf="hasItems(subitem) && !levelExclude.includes(subitem.label)" aria-expanded="false" class="sidebar-nav sub-menu nav-third-level">
                <li *ngFor="let subSubitem of subitem.subItems" class="nav-item">
                  <a [attr.data-parent]="subSubitem.parentId" [routerLinkActive]="['active']" [routerLink]="subSubitem.link"
                     class="nav-link nav-link-ref" >
                    <i *ngIf="subitem.icon" [attr.data-feather]="subitem.icon" appFeatherIcon class="link-icon"></i>
                    {{ subSubitem.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
     
      </ng-container>
    </ul>    -->



    <!-- <ng-container>
        <li class="nav-item">

          <a class="nav-link" target="_blank" (click)="openUrl()">
            <i   ><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14 " viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></i>
            <span class="link-title"></span>  
            <small class="name" style="
            margin-left: 14px;"> User Manual </small>
          </a>


          </li> 
      </ng-container> -->
    <!--   <ng-container>
        <li class="nav-item">

          <a class="nav-link" target="_blank" href="https://pay10.com/file/integration_doc.pdf">
            <i   ><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14 " viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></i>
            <span class="link-title"></span>  
            <small class="name" style="
            margin-left: 14px;">Integration Kit</small>
          </a>


          </li> 
      </ng-container> -->
    <!-- <ng-container>
        <li class="nav-item">

          <a class="nav-link" target="_blank" href="https://uat.pay10.com/crm/jsp/adminRestrictions">
            <i   ><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14 " viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg></i>
            <span class="link-title"></span>  
            <small class="name" style="
            margin-left: 14px;"> Risk & Monitoring </small>
          </a>


          </li> 
      </ng-container> -->


<!-- NEW SIDEBAR WITHOUT OVERLAPPING -->
    <ul #sidebarMenu class="sidebar-nav metismenu list-unstyled" id="sidebar-menu">
      <ng-container #menuListItem>

        <ng-container *ngFor="let item of menuItems;let i=index;">
          <li *ngIf="item.isTitle" class="nav-item nav-category list-unstyled d-none">{{ item.label }}</li>
          <li *ngIf="!item.isTitle" class="nav-item" (click)="isOpen($event,i)" id="{{i}}"> <a *ngIf="hasItems(item)"
              class="nav-link" href="javascript:void(0);"> <i *ngIf="item.icon" [attr.data-feather]="item.icon"
                appFeatherIcon class="link-icon"></i> <span class="link-title"></span> <small class="name">{{ item.label

                }}</small> <span appFeatherIcon class="link-arrow" data-feather="chevron-down"></span> </a> <a
              *ngIf="!hasItems(item)" [attr.data-parent]="item.parentId" [routerLink]="item.link"
              class="nav-link nav-link-ref" (click)="openUrl(item.link)"> <i *ngIf="item.icon"
                [attr.data-feather]="item.icon" appFeatherIcon class="link-icon"></i> <span class="link-title"></span>
              <small class="name">{{ item.label }}</small> <span *ngIf="item.badge"
                class="badge bg-{{item.badge.variant}}">{{item.badge.text}}</span> </a>
            <ul *ngIf="hasItems(item)" aria-expanded="false" class="sidebar-nav sub-menu nav-second-level d-none"
              id="{{i}}sub">
              <li *ngFor="let subitem of item.subItems;let j=index" [ngClass]="{'side-nav-item': hasItems(subitem)}"
                class="nav-item" id="{{i}}{{j}}" (click)="isOpenSubMenu(i,j,$event)"> <a
                  *ngIf="hasItems(subitem) && !levelExclude.includes(subitem.label)"
                  class="nav-link side-nav-link-a-ref" href="javascript:void(0);"> <i *ngIf="subitem.icon"
                    [attr.data-feather]="subitem.icon" appFeatherIcon class="link-icon"></i> <span class="link-title">

                    {{ subitem.label }}</span> <span appFeatherIcon class="link-arrow"
                    data-feather="chevron-down"></span> </a> <a (click)="linkUrl(subitem.link)"
                  *ngIf="!hasItems(subitem) || (hasItems(subitem) && levelExclude.includes(subitem.label))"
                  [attr.data-parent]="subitem.parentId" [routerLink]="subitem.link" class="nav-link nav-link-ref"> <i
                    *ngIf="subitem.icon" [attr.data-feather]="subitem.icon" appFeatherIcon class="link-icon"></i> {{

                  subitem.label }} </a>
                <ul *ngIf="hasItems(subitem) && !levelExclude.includes(subitem.label)" aria-expanded="false"
                  class="sidebar-nav sub-menu nav-third-level">
                  <li *ngFor="let subSubitem of subitem.subItems" class="nav-item"> <a
                      [attr.data-parent]="subSubitem.parentId" [routerLinkActive]="['active']"
                      [routerLink]="subSubitem.link" class="nav-link nav-link-ref"> <i *ngIf="subitem.icon"
                        [attr.data-feather]="subitem.icon" appFeatherIcon class="link-icon"></i> {{ subSubitem.label }}
                    </a> </li>
                </ul>
              </li>
            </ul>
          </li>
        </ng-container>
      </ng-container>
    </ul>


    <!--- Sidemenu end -->
    <!-- <ul class="nav flex-column flex-nowrap text-truncate left-menu">
      <li class="nav-item" *ngFor="let n of menuItems" (click)="select('main', n.label,$event);" [ngClass]="{active: isActive('main', n.label)}">
        <a class="text-white">{{n.label}}</a>
        <ul style="display:none;">
          <li class="nav-item" *ngFor="let child of n.subItems" [ngClass]="{active: isActive('sub', child.label)}" (click)="select('sub', child.label, $event);">
            <a class="text-white">{{child.label}}</a>
          </li>
        </ul>
      </li>
    </ul> -->
  </div>
</nav>